/**
 * The Stasht map pin, as SVG markup. One source for the live map's fallback
 * icon and the PNG the static previews use (scripts/build-marker-png.mjs).
 */

import type { StaticMapPin } from "@/lib/map/staticMapImage";

export const STASHT_MARKER_WIDTH = 50;
export const STASHT_MARKER_HEIGHT = 62;
export const PUBLIC_MARKER_FILL = "#737373";
export const STASHT_MARKER_FILL = "#fd6e12";
export const STASHT_MARKER_STROKE = "#ffffff";

/**
 * The Stasht pin for static previews. Mapbox fetches it server-side, so it
 * is served from the public site (built by `npm run build:marker-png`).
 */
export const STASHT_STATIC_PIN: StaticMapPin = {
  url: "https://stasht.app/markers/stasht-pin.png",
  url2x: "https://stasht.app/markers/stasht-pin@2x.png",
  width: STASHT_MARKER_WIDTH,
  height: STASHT_MARKER_HEIGHT,
};

export const stashtMarkerSvg = ({ fill = STASHT_MARKER_FILL, stroke = STASHT_MARKER_STROKE } = {}): string =>
  `
    <svg width="${STASHT_MARKER_WIDTH}" height="${STASHT_MARKER_HEIGHT}" viewBox="0 0 50 62" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="20" r="20" fill="${fill}" opacity="0.95" />
      <path d="M25 40 L17 35 L25 62 L33 35 Z" fill="${fill}" opacity="0.95" />
      <g transform="translate(13 8)" stroke="${stroke}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">
        <path d="M12 4V2" />
        <path d="M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4" />
        <path d="M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z" />
      </g>
    </svg>
  `.trim();
